import { Component, OnInit } from '@angular/core';

import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { NbToastrService, NbComponentStatus, NbGlobalLogicalPosition } from '@nebular/theme';

@Component({
    selector: 'ngx-base-hm',
    templateUrl: './base-hm.component.html',
    styleUrls: ['./base-hm.component.scss'],
})
export class BaseHmComponent implements OnInit {

    constructor(
        protected hmService: HappyMammaService,
        protected toastrService: NbToastrService) {
    }

    ngOnInit() {
    }

    protected showToast(status: NbComponentStatus, title: string, body: string=null) {
        const position = NbGlobalLogicalPosition.BOTTOM_END;
        this.toastrService.show(body, title, { position, status} );
    }
}

